<template>
  <div class="paymentContainer">
    <div class="paymentSubGrid imgGrid">
      <p class="nunitoBold accountText mt-5">
        {{ $t('k_prepare_child') }}
      </p>
      <p class="ralewayBold accountText2 mt-3">
        {{ $t('k_best_app') }}
      </p>
      <h2 class="hrLine2"></h2>
      <p class="ralewayBold accountText3 mb-3">
        {{ trialDaysTitleText }}
      </p>
      <div
        v-if="couponAppliedMessage"
        class="ralewayBold accountTextAppliedCoupon mt-3"
      >
        {{ couponAppliedMessage }}
      </div>
      <div
        v-if="appliedCoupon"
        class="ralewayRegular accountTextAppliedCoupon2 mt-3"
      >
        {{ $t('k_applied_coupon_text_top') }}
      </div>

      <p class="ralewayBold accountText4 mt-3">
        {{ $t('k_choose_plan') }}
      </p>
    </div>
    <div class="gridPlan">
      <div class="planButton1" @click="onClickElement(1, $event)">
        <img
          v-bind:class="{
            imgBestValueSelected: itemSelected == 1,
            imgBestValueHidden: appliedCoupon
          }"
          class="imgBestValue"
          src="@/assets/images/best_value_box.png"
        />
        <div
          class="planContainer"
          v-bind:class="{ planContainerSelected: itemSelected == 1 }"
        >
          <p class="nunitoBold planText1 mt-2">
            {{ $t('k_subscription_yearly').toUpperCase() }}
          </p>
          <p class="nunitoBold planText2">
            {{
              Number(
                this.subYearly && this.subYearly.unit_amount / 100 / 12
              ).toFixed(2)
            }}
            {{ currency }}/{{ $t('k_subscription_month') }}
          </p>
          <p class="nunitoBold planText3">
            {{
              Number(
                this.subYearly && this.subYearly.unit_amount / 100
              ).toFixed(2)
            }}{{ currency }}
            {{ $t('k_plan_annual_title') }}
          </p>
        </div>
      </div>
      <div class="planButton2" @click="onClickElement(2, $event)">
        <div
          class="planContainer"
          v-bind:class="{ planContainerSelected: itemSelected == 2 }"
        >
          <p class="nunitoBold planText1 mt-2">
            {{ $t('k_subscription_monthly').toUpperCase() }}
          </p>
          <p class="nunitoBold planText2">
            {{
              Number(
                this.subMonthly && this.subMonthly.unit_amount / 100
              ).toFixed(2)
            }}
            {{ currency }}/{{ $t('k_subscription_month') }}
          </p>
          <p class="nunitoBold planText3">
            {{ $t('k_plan_monthly_title') }}
          </p>
        </div>
      </div>
    </div>
    <div class="grid mt-10">
      <p class="ralewayBold formLeftText mt-5">{{ $t('k_info_payment') }}</p>
      <p class="ralewayRegular weAcceptText mt-5">
        {{ $t('k_accepted_cards') }}
      </p>
      <div class="cardsContainer mt-5">
        <img class="cardsImage" src="@/assets/images/credit_amex_icon.png" />
        <img
          class="cardsImage"
          src="@/assets/images/credit_mastercard_icon.png"
        />
        <img
          class="cardsImage"
          src="@/assets/images/credit_visa_electron_icon.png"
        />
        <img class="cardsImage" src="@/assets/images/credit_visa_icon.png" />
      </div>
    </div>
    <div class="formContainer mt-10">
      <div class="formElement">
        <label class="ralewayBold formInputLabel" for="cardNumber">{{
          $t('k_card_number')
        }}</label>
        <div id="cardStripe" name="cardNumber" class="formInput"></div>
      </div>
      <div class="formElementNameHalf1">
        <label class="ralewayBold formInputLabel" for="name">{{
          $t('k_name_title')
        }}</label>
        <input
          class="formInput ralewayRegular"
          type="text"
          name="name"
          v-model="name"
          v-bind:placeholder="$t('k_name_title')"
        />
      </div>
      <div class="formElementNameHalf2">
        <label class="ralewayBold formInputLabel" for="surname">{{
          $t('k_surname_title')
        }}</label>
        <input
          class="formInput ralewayRegular"
          type="text"
          name="surname"
          v-model="surname"
          v-bind:placeholder="$t('k_surname_title')"
        />
      </div>
      <div class="formElementPromo mb-5">
        <div class="promoInput">
          <input
            class="formInputPromo formInput ralewayRegular"
            type="text"
            name="promo"
            v-model="promo"
            v-bind:placeholder="$t('k_insert_promo')"
            v-bind:readonly="appliedCoupon"
          />
          <button
            class="ralewayRegular buttonPromo"
            type="button"
            name="promo"
            v-on:click="applyCoupon(promo)"
          >
            {{ appliedCoupon ? $t('k_remove_title') : $t('k_apply_title') }}
          </button>
        </div>
        <p
          class="ralewayRegular appliedCouponText mt-3"
          v-if="showCouponAppliedMessage"
        >
          {{ couponAppliedMessage }}
        </p>
        <span class="ralewayRegular appliedCouponText" v-if="couponNotValid">{{
          $t('k_coupon_not_valid')
        }}</span>
        <br />
        <span class="ralewayRegular trialText" v-if="!trialInfo">{{
          getTrialText()
        }}</span>
      </div>
      <p class="ralewayBold amountLabel">{{ $t('k_amount_title') }}</p>
      <div class="amountValueContainer">
        <span class="ralewayBold couponOldPrice mr-2"
          >{{ getOriginalPriceWithoutCoupon() }}
          {{ getOriginalPriceWithoutCouponSymbol() }}</span
        >
        <span class="ralewayBold amountValue"
          >{{ subPriceWithUnit ? subPriceWithUnit.toFixed(2) : '' }}
          {{ `${currency}` }}</span
        >
      </div>
      <h2 class="hrLineAmount"></h2>
      <div class="stButton payButton" v-on:click="onClickPayPremium">
        <div class="stButtonCaption nunitoBold">
          {{ $t('k_go_premium') }}
        </div>
      </div>
      <div
        class="paySocialButton payProviderButton"
        v-if="paymentRequestSupport"
      >
        <div class="stButtonCaption nunitoBold" v-on:click="onClickPaySocial">
          <div>
            <p>
              {{ $t('k_pay_apple') }}
              <font-awesome-icon
                v-if="socialIcon"
                v-bind:icon="socialIcon"
                transform="grow-8 down-1 right-4"
                size="lg"
              />
            </p>
          </div>
        </div>
      </div>
      <p class="payText">
        {{
          $t('k_plan_enabled_future', {
            price: subPriceWithUnit ? subPriceWithUnit.toFixed(2) : ''
          })
        }}
      </p>
      <div class="payInfo1 ralewayRegular mt-2">
        <img class="payTextImg mt-2" src="@/assets/images/lock_icon.png" />
        <p class="mt-4">{{ $t('k_info_payment_crypted') }}</p>
        <img
          class="payTextImg mt-2"
          src="@/assets/images/powered_by_stripe_icon.png"
        />
      </div>
      <div class="payInfo2 ralewayRegular  mt-2">
        <img
          class="payTextImg mt-2"
          src="@/assets/images/money_back_icon.png"
        />
        <p class="mt-4">{{ $t('k_warranty') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getSubscriptionCoupons } from '../services/parameters'
import api from '../plugins/api'
import { trackEvent } from '../plugins/analyticsTracker'
import { getStripeObject } from '../plugins/stripe'

export default {
  data() {
    return {
      queryPartnerId: null,
      paymentRequestEnabled: false,
      userInfo: '',
      password: '',
      submitted: false,
      premium: true,
      itemSelected: 1,
      name: null,
      surname: null,
      promo: null,
      currency: '€',
      platform: null,
      socialIcon: null,
      paymentRequestData: null,
      stripe: null,
      subYearly: null,
      subMonthly: null,
      appliedCoupon: null,
      validSubCoupons: [],
      paymentRequestSupport: false,
      stripeCustomer: null,
      cardValid: false,
      cardElement: null,
      couponNotValid: false,
      stripeCoupons: [],
      couponAppliedMessage: '',
      trialInfo: null,
      subPrice: null,
      subPriceWithUnit: null,
      showCouponAppliedMessage: false
    }
  },
  components: {},
  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      this.getTrialDaysTitleText()
      this.getCouponAppliedMessage()
    }
  },
  computed: {
    ...mapState({
      email: state => state.userInfo?.email
    })
  },
  async mounted() {
    const revenuecatRespone = await api.get(`/user/revenueCat`)
    const subs =
      revenuecatRespone &&
      revenuecatRespone.data &&
      revenuecatRespone.data.subscriptions
        ? revenuecatRespone.data.subscriptions
        : []
    if (subs.length > 0)
      this.$router.push({
        path: '/profile',
        query: this.query
      })
    this.stripe = await getStripeObject()
    const fontSize = window.innerWidth >= 1200 ? '18.75px' : '15px'
    this.elements = this.stripe.elements({
      fonts: [
        {
          src:
            'url(https://fonts.gstatic.com/s/raleway/v17/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaooCM.woff)',
          family: 'Raleway'
        }
      ],
      locale: this.$i18n.locale
    })
    // Create a Card Element and pass some custom styles to it.
    this.cardElement = this.elements.create('card', {
      classes: {
        base: 'stripeCard'
      },
      hidePostalCode: true,
      style: {
        base: {
          color: '#6a6a6a',
          fontFamily: 'Raleway',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSmoothing: 'antialiased',
          fontSize: fontSize
        }
      }
    })
    this.cardElement.mount('#cardStripe')
    this.cardElement.on('change', event => {
      if (event.complete) {
        this.cardValid = true
      } else if (event.error) {
        this.cardValid = false
      }
    })

    this.validSubCoupons = await getSubscriptionCoupons()
    if (/Android/i.test(navigator.userAgent)) {
      this.platform = 'android'
      this.socialIcon = ['fab', 'google-pay']
      console.log(this.platform)
    } else if (/iPhone|iPad|Macintosh|iPod/i.test(navigator.userAgent)) {
      this.platform = 'ios'
      this.socialIcon = ['fab', 'apple-pay']
      console.log(this.platform)
    }
    this.queryPartnerId = this.$route.query.partnerId
    console.log(this.queryPartnerId)
    const pricesInfoResp = await api.get('/user/stripe/subscription/info', {
      params: {
        partnerId: this.queryPartnerId
      }
    })
    this.trialInfo = pricesInfoResp.data.trialInfo
    this.stripeCustomer = pricesInfoResp.data.customer
    this.stripeCoupons = pricesInfoResp.data.coupons
    this.subYearly = pricesInfoResp.data.subscriptions.find(
      x => x && x.recurring && x.recurring.interval == 'year'
    )
    this.subMonthly = pricesInfoResp.data.subscriptions.find(
      x => x && x.recurring && x.recurring.interval == 'month'
    )
    this.currency =
      this.subYearly.currency == 'eur'
        ? '€'
        : this.subYearly.currency == 'gbp'
        ? '£'
        : '$'

    const queryCoupon = this.$route.query.code
    const queryCouponType = this.$route.query.codeType
    if (queryCouponType && queryCouponType == 'month') this.onClickElement(2)
    if (queryCouponType && queryCouponType == 'year') this.onClickElement(1)
    if (queryCoupon) {
      this.applyCoupon(queryCoupon)
    } else {
      this.calculateSubscriptionPrice()
    }
  },
  methods: {
    getTrialText: function() {
      const elem = this.itemSelected == 1 ? this.subYearly : this.subMonthly
      return elem
        ? !elem.trial || elem.trial == 0
          ? ''
          : this.$i18n.t('k_trial_text', [elem.trial])
        : ''
    },
    getTrialDaysTitleText: function() {
      const elem = this.itemSelected == 1 ? this.subYearly : this.subMonthly
      this.trialDaysTitleText = elem
        ? !elem.trial || elem.trial == 0
          ? ''
          : this.$i18n.t('k_try_7_days_title', [elem.trial])
        : ''
    },
    getCouponAppliedMessage: function() {
      if (!this.appliedCoupon) return null
      const pricePerMonth =
        this.itemSelected == 1
          ? this.subYearly.unit_amount / 12
          : this.subMonthly.unit_amount
      const price =
        this.itemSelected == 1
          ? this.subYearly.unit_amount
          : this.subMonthly.unit_amount
      const durationCoupon = this.appliedCoupon.duration
      const amountString = this.appliedCoupon.amount_off
        ? this.appliedCoupon.amount_off / 100 + this.currency
        : this.appliedCoupon.percent_off + '%'
      switch (durationCoupon) {
        case 'repeating':
          if (this.itemSelected != 2) break
          const durationMonths = this.appliedCoupon.duration_in_months
          let monthlyOff = this.appliedCoupon.amount_off
            ? this.appliedCoupon.amount_off
            : pricePerMonth * (this.appliedCoupon.percent_off / 100)
          monthlyOff = monthlyOff < 0 ? 0 : monthlyOff
          this.couponAppliedMessage = this.appliedCoupon.percent_off
            ? this.$i18n.t('k_coupon_applied_repeat_percent_title', [
                amountString,
                durationMonths,
                price / 100
              ]) + this.currency
            : this.$i18n.t('k_coupon_applied_repeat_amount_title', [
                amountString,
                durationMonths,
                price / 100
              ]) + this.currency
          break
        case 'once':
        case 'forever':
          this.couponAppliedMessage = this.$i18n.t(
            durationCoupon == 'once'
              ? this.appliedCoupon.percent_off
                ? 'k_coupon_applied_repeat_percent_once'
                : 'k_coupon_applied_repeat_amount_once'
              : this.appliedCoupon.percent_off
              ? 'k_coupon_applied_repeat_percent_forever'
              : 'k_coupon_applied_repeat_amount_forever',
            [amountString, price / 100]
          )
          this.couponAppliedMessage +=
            durationCoupon == 'once' ? this.currency : ''
          break
      }
    },
    onClickPayPremium: async function() {
      trackEvent(this.$constants.WEB_PAY_SUBS_PRESSED)
      try {
        const premiumPaymentMethodData = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: {
            name: `${this.name} ${this.surname}`
          }
        })
        this.onPaymentRequestHandler(
          {
            paymentMethod: premiumPaymentMethodData.paymentMethod
          },
          true
        )
      } catch (error) {
        await this.$store.dispatch('setError', {
          errorKey: 'k_stripe_error_title',
          errorSubKey: 'k_stripe_error_subtitle',
          errorImage: '@/assets/images/mosquita_error.png',
          redirect: '/profile'
        })
        this.$router.push({
          path: '/error'
        })
      }
    },
    onClickPaySocial: async function() {
      trackEvent(
        this.platform == 'ios'
          ? this.$constants.WEB_PAY_SUBS_APPLEPAY
          : this.$constants.WEB_PAY_SUBS_GOOGLEPAY
      )
      this.paymentRequestSupport = await this.paymentRequestData.canMakePayment()
      if (this.paymentRequestSupport) this.paymentRequestData.show()
    },
    onClickElement: async function(index, event) {
      trackEvent(
        index == 1
          ? this.$constants.WEB_PAY_SUBS_YEARLY
          : this.$constants.WEB_PAY_SUBS_MONTHLY
      )
      if (
        this.appliedCoupon &&
        this.appliedCoupon.duration == 'repeating' &&
        index != 2
      ) {
        if (event) event.preventDefault()
        this.handleNotValidCoupon()
        return
      }
      this.itemSelected = index
      const itemElement =
        this.itemSelected == 1 ? this.subYearly : this.subMonthly
      this.calculateSubscriptionPrice()
      this.paymentRequestData = this.stripe.paymentRequest({
        currency: itemElement.currency,
        country: 'IT',
        total: {
          label: 'Smart Tales Premium',
          amount: Number(this.subPrice)
        },
        requestPayerName: true,
        requestPayerEmail: true
      })

      // Check if the Payment Request is available (or Apple Pay on the Web).
      this.paymentRequestSupport = await this.paymentRequestData.canMakePayment()
      this.paymentRequestData.on('paymentmethod', this.onPaymentRequestHandler)
    },
    calculateSubscriptionPrice() {
      if (!this.subYearly || !this.subMonthly) return 0
      let finalPrice = null
      const price =
        this.itemSelected == 1
          ? this.subYearly.unit_amount
          : this.subMonthly.unit_amount
      const pricePerMonth =
        this.itemSelected == 1
          ? this.subYearly.unit_amount / 12
          : this.subMonthly.unit_amount
      if (!this.appliedCoupon) {
        finalPrice = price
        this.showCouponAppliedMessage = false
      } else {
        this.showCouponAppliedMessage = true
        const durationCoupon = this.appliedCoupon.duration
        switch (durationCoupon) {
          case 'repeating':
            if (this.itemSelected != 2) break
            let monthlyOff = this.appliedCoupon.amount_off
              ? this.appliedCoupon.amount_off
              : pricePerMonth * (this.appliedCoupon.percent_off / 100)
            monthlyOff = monthlyOff < 0 ? 0 : monthlyOff
            finalPrice = price - monthlyOff
            break
          case 'once':
          case 'forever':
            const offAmount = this.appliedCoupon.percent_off
              ? price * (this.appliedCoupon.percent_off / 100)
              : this.appliedCoupon.amount_off
            finalPrice = price - offAmount
            break
        }
      }
      this.subPriceWithUnit = finalPrice / 100
      this.subPrice = Math.round(finalPrice)
      this.getTrialDaysTitleText()
      this.getCouponAppliedMessage()
    },
    handleNotValidCoupon() {
      const titleKey = this.$i18n.t('k_coupon_not_available_for_subscription')
      console.log(titleKey)
      const buttonKey = this.$i18n.t('k_confirm_title')
      this.$confirm({
        message: titleKey,
        button: {
          yes: buttonKey
        }
      })
    },
    getOriginalPriceWithoutCoupon() {
      if (this.appliedCoupon) {
        const price =
          this.itemSelected == 1
            ? this.subYearly.unit_amount / 100
            : this.subMonthly.unit_amount / 100
        return price.toFixed(2)
      } else return ''
    },
    getOriginalPriceWithoutCouponSymbol() {
      if (this.appliedCoupon) {
        return this.currency
      } else return ''
    },
    applyCoupon(couponName) {
      try {
        if (this.appliedCoupon) {
          //remove coupon
          this.appliedCoupon = null
          this.promo = null
          this.couponAppliedMessage = null
        } else {
          this.couponAppliedMessage = null
          const validCoupon = this.validSubCoupons.find(
            x => x.toLowerCase() == couponName.toLowerCase()
          )
          this.appliedCoupon =
            validCoupon &&
            this.stripeCoupons.find(
              x => x.name.toLowerCase() == validCoupon.toLowerCase()
            )
          if (
            this.appliedCoupon &&
            this.appliedCoupon.duration == 'repeating' &&
            this.itemSelected == 1
          ) {
            this.appliedCoupon = null
            this.handleNotValidCoupon()
            this.promo = null
          }
          this.couponNotValid = !this.appliedCoupon
          const itemElement =
            this.itemSelected == 1 ? this.subYearly : this.subMonthly
          this.calculateSubscriptionPrice()
          this.paymentRequestData = this.stripe.paymentRequest({
            currency: itemElement.currency,
            country: 'IT',
            total: {
              label: 'Smart Tales Premium',
              amount: Number(this.subPrice)
            },
            requestPayerName: true,
            requestPayerEmail: true
          })
          this.paymentRequestData.on(
            'paymentmethod',
            this.onPaymentRequestHandler
          )
          trackEvent(
            this.appliedCoupon
              ? this.$constants.WEB_PAY_PROMO_APPLIED
              : this.$constants.WEB_PAY_PROMO_ERROR
          )
        }
      } catch (error) {
        console.log('error applying coupon')
        console.log(error)
      }
    },
    onPaymentRequestHandler: async function(event, creditCard) {
      const paymentMethod = event.paymentMethod
      const priceId =
        this.itemSelected == 1 ? this.subYearly.id : this.subMonthly.id
      if (paymentMethod) {
        await api.post('/user/stripe/subscription', {
          paymentId: event.paymentMethod.id,
          coupon: this.appliedCoupon ? this.appliedCoupon.id : null,
          priceId: priceId,
          lang: this.$i18n.locale,
          stripeCustomerId: this.stripeCustomer.id,
          paywallId: 'webStandard',
          partnerId: this.queryPartnerId
        })
        if (this.queryPartnerId)
          await api.post(process.env.VUE_APP_BACKEND_URL + '/user/tags/add', {
            tags: [this.queryPartnerId]
          })
        if (!creditCard) event.complete()
        trackEvent(this.$constants.WEB_SUBS_CONFIRMED)
        this.$router.push({ path: '/payment-success' })
      } else {
        trackEvent(this.$constants.WEB_SUBS_CANCELED)
        if (!creditCard) event.fail()
        await this.$store.dispatch('setError', {
          errorKey: 'k_stripe_error_title',
          errorSubKey: 'k_stripe_error_subtitle',
          errorImage: '@/assets/images/mosquita_error.png',
          redirect: '/profile'
        })
        this.$router.push({
          path: '/error'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.paymentContainer {
  .appliedCouponText {
    font-size: 0.838em;
    color: #54d0c6;
    text-align: left;
  }
  .trialText {
    font-size: 0.688em;
    color: var(--formColor);
    text-align: center;
  }
  .couponOldPrice {
    text-decoration: line-through;
    color: var(--subtextColor);
    font-size: 0.75em;
  }

  .imgBestValue {
    position: relative;
    bottom: -25px;
    left: -25px;
    z-index: 1000;
    width: 35%;
  }

  .payTextImg {
    width: 50%;
    align-self: center;
  }

  .payInfo1 {
    display: flex;
    flex-direction: column;
    font-size: 0.5em;
    color: var(--formColor);
    text-align: center;
    grid-row: 11;
    grid-column: 2/6;
    align-items: left;
  }

  .payInfo2 {
    display: flex;
    flex-direction: column;
    font-size: 0.5em;
    color: var(--formColor);
    text-align: center;
    grid-row: 11;
    grid-column: 8/12;
    align-items: right;
  }

  .payText {
    font-size: 0.625em;
    color: var(--formColor);
    text-align: left;
    grid-row: 10;
    grid-column: 2/12;
  }
  .payButton {
    grid-row: 7;
    grid-column: 2/12;
    padding: 5px 0px;
  }

  .payProviderButton {
    grid-row: 8;
    grid-column: 2/12;
    padding: 5px 0px;
  }

  .planContainerSelected {
    transform: scale(1.1);
    animation: scaleup 0.2s;
    opacity: 1 !important;
    border: 2px solid var(--primary) !important;
  }

  .paymentSubGrid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  @keyframes scaleup {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.1);
    }
  }

  @keyframes scaledown {
    0% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .cardsImage {
    width: 23%;
    margin-right: 4px;
  }

  .formLeftText {
    grid-column: 2/6;
    grid-row: 1;
    font-size: 0.875em;
    color: var(--formColor);
    text-align: left;
  }

  .weAcceptText {
    grid-column: 2/4;
    grid-row: 2;
    font-size: 0.875em;
    color: var(--formColor);
    text-align: left;
  }

  .cardsContainer {
    grid-column: 8/12;
    grid-row: 2;
    display: flex;
    align-items: center;
  }

  .amountLabel {
    font-size: 0.9em;
    color: var(--formColor);
    text-align: left;
    grid-row: 5;
    grid-column: 2/5;
    text-align: left;
  }

  .amountValueContainer {
    grid-row: 5;
    grid-column: 10/12;
    text-align: right;
  }

  .amountValue {
    font-size: 1em;
    color: var(--formColor);
    text-align: right;
  }

  .planContainerSelected .planText1 {
    font-size: 1.063em;
    color: var(--tertiary) !important;
  }

  .planContainerSelected.planText2 {
    font-size: 1.063em;
    color: var(--formColor);
  }
  .planContainerSelected .planText3 {
    font-size: 0.563em;
    color: var(--subtextColor);
  }

  .planContainer .planText1 {
    font-size: 1.063em;
    color: var(--formColor);
  }

  .planContainer.planText2 {
    font-size: 1.063em;
    color: var(--formColor);
  }
  .planContainer .planText3 {
    font-size: 0.563em;
    color: var(--formColor);
  }

  .helpText {
    margin: 20px 0;
    color: var(--formColor);
    grid-row: 4;
    grid-column: 2/12;
  }
  .emailContainer {
    display: flex;
    flex-direction: column;
    grid-row: 3;
    grid-column: 5/8;
    align-items: flex-start;
  }
  .imgGrid {
    align-self: center;
    grid-row: 1;
    grid-column: 1/9;
    width: 100%;
    max-width: 400px;
  }
  .accountText {
    grid-row: 1;
    grid-column: 2/12;
    font-size: 1.5em;
    color: var(--tertiary);
    line-height: 0.9em;
    text-align: left;
  }

  .accountText2 {
    grid-row: 3;
    grid-column: 2/12;
    font-size: 0.9em;
    color: var(--formColor);
    text-align: left;
  }
  .accountText4 {
    grid-row: 8;
    grid-column: 2/6;
    font-size: 0.75em;
    color: var(--formColor);
    align-self: center;
    text-align: left;
  }

  .accountTextAppliedCoupon {
    grid-row: 6;
    grid-column: 2/12;
    font-size: 0.85em;
    color: var(--formColor);
    align-self: center;
    text-align: left;
  }
  .accountTextAppliedCoupon2 {
    grid-row: 7;
    grid-column: 2/12;
    font-size: 0.85em;
    color: var(--formColor);
    align-self: center;
    text-align: left;
  }

  .accountText3 {
    grid-row: 5;
    grid-column: 2/12;
    font-size: 0.88em;
    color: var(--formColor);
    align-self: center;
    text-align: left;
  }
  .stripeImg {
    grid-row: 6;
    grid-column: 10/12;
    width: 130%;
    align-self: flex-end;
  }

  .emailText {
    grid-row: 3;
    grid-column: 2/4;
    font-size: 0.875em;
    color: var(--tertiary);
  }

  .gridPlan {
    grid-template-columns: repeat(20, 1fr);
    display: grid;
  }

  .planContainer {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 6px rgba(85, 30, 210, 0.19);
    border-radius: 13px;
    border: 2px solid gray;
    width: 100%;
    height: 0;
    padding-bottom: 75%;
    opacity: 0.25;
    cursor: pointer;
  }

  .planText {
    display: flex;
    grid-row: 5;
    grid-column: 5/7;
    font-size: 0.875em;
    color: var(--tertiary);
  }

  .forgotText {
    grid-row: 3;
    grid-column: 2/4;
    font-size: 0.75em;
    color: var(--primary);
  }

  .imgGrid .subheaderText {
    grid-row: 2;
    grid-column: 1/9;
    font-size: 1.56em;
    color: var(--secondary);
  }
  .imgBestValueSelected {
    border: none !important;
    transform: scale(1.1);
    animation: scaleup 0.2s;
    opacity: 1 !important;
  }

  .imgBestValueHidden {
    opacity: 0 !important;
  }

  .planButton1 {
    grid-column: 4/10;
  }

  .planButton2 {
    grid-column: 12/18;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .buttonCaption {
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .hrLine {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 10px;
    grid-row: 2;
    grid-column: 2/12;
  }

  .hrLineAmount {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 10px;
    grid-row: 6;
    grid-column: 2/12;
  }

  .hrLine2 {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-row: 4;
    grid-column: 2/12;
  }

  .hrLine3 {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid var(--line2);
    line-height: 0.1em;
    margin: 20px 0 20px;
    grid-row: 6;
    grid-column: 2/12;
  }

  .hrLine span {
    padding: 0 10px;
    background: #fff;
    color: var(--line1);
    font-size: 0.5em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 10px;
  }

  .promoInput {
    display: flex;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .buttonPromo {
    margin: 1px 1px;
    padding: 0px 2px;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 0.725em;
    background-color: #dedddd;
    color: var(--formColor);
    outline: none;
    white-space: nowrap;
  }

  .formInputPromo {
    flex-grow: 2;
    border: 0px !important;
  }

  .formElement {
    grid-column: 2/12;
    grid-row: 1;
  }

  .formElementPromo {
    grid-column: 2/12;
    grid-row: 4;
  }

  .formElementPromoBtn {
    margin-left: 0px;
  }

  .formElementNameHalf1 {
    grid-column: 2/7;
    grid-row: 2;
  }
  .formElementNameHalf2 {
    grid-column: 7/12;
    grid-row: 2;
  }

  .formInputLabel {
    display: flex;
    font-size: 0.75em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 0.938em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
    .cardsContainer {
      grid-column: 9/12;
    }
    .imgGrid {
      max-width: 900px;
    }

    .stripeImg {
      max-width: 100px;
      grid-column: 7/8;
    }

    .planText1 {
      margin-top: 3rem !important;
    }

    input::placeholder {
      color: var(--formColor);
    }
  }
  .stripeCard {
    padding-top: 12.5px;
    padding-bottom: 12.5px;
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
